/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_RunsInputs */

const cs_settings_automation_runs = /** @type {(inputs: Settings_Automation_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední běhy`)
};

const en_settings_automation_runs = /** @type {(inputs: Settings_Automation_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent runs`)
};

/**
* | output |
* | --- |
* | "Recent runs" |
*
* @param {Settings_Automation_RunsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_runs = /** @type {((inputs?: Settings_Automation_RunsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_RunsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_runs(inputs)
	return cs_settings_automation_runs(inputs)
});